module.exports = __webpack_public_path__ + "static/media/angular.5b15e7f9.png";